import classNames from 'classnames'
import { observer } from 'mobx-react'
import { useEffect, useRef } from 'react'

const NewsTabs = observer(
  ({
    setTopic,
    topic,
    dt,
  }: {
    setTopic: (value: any) => void
    topic: string
    dt: any
  }) => {
    const tabsCont = useRef<any>(null),
      line = useRef<any>(null)

    // useEffect(() => {
    //   if (!tabsCont.current || !line.current) return

    //   if (dt.indexOf(topic) == -1) {
    //     ;(line.current as HTMLElement).style.setProperty('--width', `${0}px`)
    //     return
    //   }

    //   const tabs = tabsCont.current.querySelectorAll('.news-page__tab')
    //   if (tabs) {
    //     let tabIndex = dt.indexOf(topic)
    //     if (tabIndex == -1) return
    //     ;(line.current as HTMLElement).style.setProperty(
    //       '--width',
    //       `${tabs[tabIndex].getBoundingClientRect().width}px`,
    //     )
    //     if (window.innerWidth <= 1440) {
    //       ;(line.current as HTMLElement).style.setProperty(
    //         'transform',
    //         `translateX(${
    //           tabs[tabIndex].offsetLeft - document.body.scrollLeft
    //         }px)`,
    //       )
    //     } else {
    //       ;(line.current as HTMLElement).style.setProperty(
    //         'transform',
    //         `translateX(${
    //           (tabs[tabIndex] as any)!.getBoundingClientRect().left -
    //           tabsCont.current!.getBoundingClientRect().left
    //         }px)`,
    //       )
    //     }
    //   }
    // }, [topic])

    // useEffect(() => {
    //   const tabs = tabsCont.current.querySelectorAll('.news-page__tab')
    //   if (tabs) {
    //     if (dt.indexOf(topic) != -1) {
    //       setTimeout(() => {
    //         ;(line.current as HTMLElement).style.setProperty(
    //           '--width',
    //           `${tabs[0].getBoundingClientRect().width}px`,
    //         )
    //       }, 10)
    //     } else {
    //       ;(line.current as HTMLElement).style.setProperty('--width', `${0}px`)
    //     }
    //   }
    // }, [])
    return (
      <div className="news-page__tabs" ref={tabsCont}>
        {dt.map((t: any, i: number) => (
          <div
            className={classNames('news-page__tab', t == topic && 'active')}
            key={i}
            onClick={() => setTopic(t)}
          >
            <span>{t}</span>
          </div>
        ))}
        {/* <div className="news-page__line" ref={line}></div> */}
      </div>
    )
  },
)
export default NewsTabs
